import React from 'react';
import { SmartphoneIcon, LaptopIcon, TabletIcon } from 'lucide-react';
import { steps } from '../../data/content';
export function Steps() {
  return <section className="bg-white py-12 lg:py-20" aria-labelledby="steps-title" data-id="element-447" data-mp="y4rf9uqba8po">
      
    </section>;
}